import React, { useEffect, useState } from 'react';
import { DollarSign, BookOpenCheck, BadgeDollarSign, Wallet } from 'lucide-react';

const RevenueSummaryCards = ({ data }) => {
    const [cardWidth, setCardWidth] = useState('100%');

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            if (width >= 1024) {
                setCardWidth('calc(25% - 12px)');
            } else if (width >= 768) {
                setCardWidth('calc(50% - 12px)');
            } else {
                setCardWidth('100%');
            }
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const cardBase = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '20px',
        borderRadius: '16px',
        boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
        transition: 'transform 0.3s ease',
        boxSizing: 'border-box',
        borderLeft: '4px solid',
        cursor: 'pointer',
    };

    const iconWrapper = {
        padding: '12px',
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    };

    const textStyle = {
        fontSize: '14px',
        color: '#4B5563',
        fontWeight: 600,
        marginBottom: '4px',
        textTransform: 'uppercase',
    };

    const numberStyle = {
        fontSize: '24px',
        fontWeight: 700,
    };

    const formatCurrency = (amount) => {
        return `KWD ${amount?.toLocaleString('en-IN') || 0}`;
    };

    const cards = [
        {
            label: 'Product Revenue',
            value: formatCurrency(data.productRevenue),
            bg: '#E0F2FE',
            border: '#0284C7',
            icon: <DollarSign color="#075985" size={28} />,
            iconBg: '#BAE6FD',
            textColor: '#075985',
        },
        {
            label: 'Class Revenue',
            value: formatCurrency(data.classRevenue),
            bg: '#FEF9C3',
            border: '#EAB308',
            icon: <BookOpenCheck color="#B45309" size={28} />,
            iconBg: '#FDE68A',
            textColor: '#B45309',
        },
        {
            label: 'Subscription Revenue',
            value: formatCurrency(data.subscriptionRevenue),
            bg: '#F5F3FF',
            border: '#8B5CF6',
            icon: <BadgeDollarSign color="#6D28D9" size={28} />,
            iconBg: '#DDD6FE',
            textColor: '#6D28D9',
        },
        {
            label: 'Total Revenue',
            value: formatCurrency(data.totalRevenue),
            bg: '#DCFCE7',
            border: '#22C55E',
            icon: <Wallet color="#15803D" size={28} />,
            iconBg: '#BBF7D0',
            textColor: '#15803D',
        },
    ];

    return (
        <div
            style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '16px',
                width: '100%',
                marginBottom: '20px',
            }}
        >
            {cards.map((card, index) => (
                <div
                    key={index}
                    style={{
                        ...cardBase,
                        backgroundColor: card.bg,
                        borderLeftColor: card.border,
                        width: cardWidth,
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.03)')}
                    onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                >
                    <div>
                        <div style={textStyle}>{card.label}</div>
                        <div style={{ ...numberStyle, color: card.textColor }}>{card.value}</div>
                    </div>
                    <div style={{ ...iconWrapper, backgroundColor: card.iconBg }}>{card.icon}</div>
                </div>
            ))}
        </div>
    );
};

export default RevenueSummaryCards;
